import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=2768ec7b&scoped=true"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"
import style0 from "./Talk.vue?vue&type=style&index=0&id=2768ec7b&prod&scoped=true&lang=css"
import style1 from "./Talk.vue?vue&type=style&index=1&id=2768ec7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768ec7b",
  null
  
)

export default component.exports